export const translations = {
  fr: {
    // Global
    loading: "Chargement de votre dashboard...",
    connected: "Connecté",
    logout: "Déconnexion",
    units: "Unités",
    paid: "Payé",
    loading_orders: "Chargement des commandes...",
    loading_dots: "Chargement...",
    order_not_found: "Commande introuvable",
    
    // Navigation
    navDashboard: "Tableau de bord",
    navOrders: "Commandes",
    navProducts: "Produits",
    navSubscription: "Abonnement",
    navMarketInfo: "Infos du supermarché",
    navSettings: "Paramètres",

    // Header & Commandes List
    dashboardTitle: "Tableau de bord",
    performanceOverview: "Aperçu de vos performances en temps réel",
    orders: "Commandes",
    order_unit: "commande(s)",
    page: "Page",
    clear: "Vider",
    dashboard: "Dashboard",
    search_placeholder: "Rechercher par téléphone, ID ou n° commande…",
    no_orders_page: "Aucune commande pour cette page",
    confirm_clear_all: "⚠️ Cette action supprimera définitivement toutes les commandes.\nConfirmer ?",
    no_phone: "Numéro non fourni",
    prev: "Précédent",
    next: "Suivant",

    // Order Details Page
    order_details: "Détails de la commande",
    back: "Retour",
    client_info: "Informations client",
    phone: "Téléphone",
    address: "Adresse",
    client_note: "Note du client",
    payment_reception: "Paiement & Réception",
    payment: "Paiement",
    reception: "Réception",
    payment_proof: "Preuve de paiement",
    items_ordered: "Articles commandés",
    subtotal: "Sous-total",
    service_fee: "Frais de service",
    delivery_fee: "Frais de livraison",
    total_paid: "Total payé",

    // Buttons & Status
    btn_prepa: "Prépa",
    btn_ready: "Prête",
    btn_sent: "Envoyée",
    btn_cancel: "Annuler",
    btn_details: "Détails",
    st_pending: "En attente",
    st_preparing: "En préparation",
    st_ready: "Prête",
    st_sent: "Envoyée",
    st_canceled: "Annulée",

    // Enums
    pay_cash: "Cash",
    pay_mobile: "Paiement mobile (Bankily ou autres)",
    pay_card: "Carte",
    full_collect: "Click & Collect",
    full_delivery: "Livraison",

    // Stats Cards
    totalRevenue: "CA Total",
    totalOrders: "Commandes Totales",
    monthlyRevenue: "CA ce mois",
    monthlyOrders: "Commandes ce mois",
    sinceStart: "Depuis le début",
    currentMonth: "Mois en cours",

    // Action Cards
    manageOrders: "Gérer les commandes",
    quickAction: "Action Rapide",
    addEditCatalog: "Ajouter / modifier",
    catalog: "Catalogue",
    proTip: "Conseil Pro",
    tipText: "Ajoute au moins 8 produits attractifs pour augmenter les ventes de 20%.",

    // Lists
    latestOrders: "Dernières commandes",
    realTime: "Temps réel",
    noOrders: "Aucune commande récente.",
    client: "Client",
    topSales: "Top Ventes",
    byVolume: "Par volume",
    noSalesData: "Aucune donnée de vente.",

    // Charts
    orderVolume: "Volume Commandes",
    sales: "Ventes",
    revenue: "Revenus",

    // --- Products & Inventory ---
    inventory: "Mon Inventaire",
    add_product: "Ajouter un nouveau produit",
    product_name: "Nom du produit",
    price_mru: "Prix (MRU)",
    stock: "Stock",
    category: "Catégorie",
    new_category: "➕ Nouvelle catégorie",
    image_product: "Image du produit",
    select_image: "Sélectionner une image",
    save: "Enregistrer",
    search_product: "Rechercher un produit...",
    display_count: "Affichage de {count} produits",
    out_of_stock: "Épuisé",
    edit: "Modifier",
    rupture: "Rupture",
    restock: "Réappro",
    delete_confirm: "Supprimer ce produit ?",
    edit_product: "Modifier le produit",
    cancel: "Annuler",
    save_changes: "Enregistrer les modifications",

    // --- Subscription ---
    my_subscription: "Mon Abonnement",
    paid_months: "Mois Payés",
    year: "Année",
    send_proof: "Envoyer une preuve de paiement",
    month_concerned: "Mois concerné",
    select_month: "Choisir un mois...",
    screenshot_receipt: "Capture d'écran (Reçu)",
    confirm_payment: "Confirmer le paiement",
    processing: "Traitement...",
    annual_history: "Historique Annuel",
    not_settled: "Non réglé",
    view_receipt: "Voir le reçu",
    delete_proof_confirm: "Supprimer cette preuve de paiement ?",
    months_list: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],

    // --- Market Info ---
    public_info: "Informations publiques",
    client_contact: "Contact Client (Téléphone)",
    phone_placeholder: "Ex : 36 12 34 56",
    opening_hours_title: "Horaires d’ouverture (Semaine type)",
    opens_at: "Ouvre à",
    closes_at: "Ferme à",
    closed_all_day: "Fermé toute la journée",
    tip_closed: "Astuce : Cochez la case à gauche du jour pour le marquer comme \"Fermé\".",
    payment_methods_accepted: "Moyens de paiement acceptés",
    payment_label_placeholder: "Nom (ex: Bankily)",
    payment_value_placeholder: "Numéro / Code",
    add_payment_method: "Ajouter un moyen de paiement",
    update_success: "✅ Informations mises à jour avec succès !",
    saving: "Enregistrement en cours...",
    save_mods: "Enregistrer les modifications",
    days_list: [
      { key: "monday", label: "Lundi" },
      { key: "tuesday", label: "Mardi" },
      { key: "wednesday", label: "Mercredi" },
      { key: "thursday", label: "Jeudi" },
      { key: "friday", label: "Vendredi" },
      { key: "saturday", label: "Samedi" },
      { key: "sunday", label: "Dimanche" },
    ],

    // --- Settings (New) ---
    security: "Sécurité",
    change_password_desc: "Modifier votre mot de passe",
    current_password: "Mot de passe actuel",
    new_password: "Nouveau mot de passe",
    confirm_new_password: "Confirmation",
    update_btn: "Mettre à jour",
    pwd_changed: "Mot de passe modifié",
    error_required: "Tous les champs sont obligatoires",
    error_short: "Mot de passe trop court (min 6 caractères)",
    error_mismatch: "Les mots de passe ne correspondent pas",
    error_server: "Erreur serveur",
    language_choice: "Langue de l'interface"
  },

  ar: {
    // Global
    loading: "جاري تحميل لوحة التحكم...",
    connected: "متصل الآن",
    logout: "تسجيل الخروج",
    units: "وحدات",
    paid: "تم الدفع",
    loading_orders: "جاري تحميل الطلبات...",
    loading_dots: "جاري التحميل...",
    order_not_found: "الطلب غير موجود",

    // Navigation
    navDashboard: "لوحة التحكم",
    navOrders: "الطلبات",
    navProducts: "المنتجات",
    navSubscription: "الاشتراك",
    navMarketInfo: "معلومات المتجر",
    navSettings: "الإعدادات",

    // Header & Commandes List
    dashboardTitle: "لوحة التحكم",
    performanceOverview: "نظرة عامة على أدائك في الوقت الفعلي",
    orders: "الطلبات",
    order_unit: "طلب(ات)",
    page: "صفحة",
    clear: "مسح الكل",
    dashboard: "لوحة التحكم",
    search_placeholder: "البحث عن طريق الهاتف أو الرقم...",
    no_orders_page: "لا توجد طلبات في هذه الصفحة",
    confirm_clear_all: "⚠️ هذا الإجراء سيحذف جميع الطلبات نهائياً.\nهل أنت متأكد؟",
    no_phone: "رقم الهاتف غير متوفر",
    prev: "السابق",
    next: "التالي",

    // Order Details Page
    order_details: "تفاصيل الطلب",
    back: "رجوع",
    client_info: "معلومات العميل",
    phone: "الهاتف",
    address: "العنوان",
    client_note: "ملاحظة العميل",
    payment_reception: "الدفع والاستلام",
    payment: "الدفع",
    reception: "الاستلام",
    payment_proof: "إثبات الدفع",
    items_ordered: "الأصناف المطلوبة",
    subtotal: "المجموع الفرعي",
    service_fee: "رسوم الخدمة",
    delivery_fee: "رسوم التوصيل",
    total_paid: "إجمالي المدفوع",

    // Buttons & Status
    btn_prepa: "تحضير",
    btn_ready: "جاهز",
    btn_sent: "تم الإرسال",
    btn_cancel: "إلغاء",
    btn_details: "تفاصيل",
    st_pending: "قيد الانتظار",
    st_preparing: "قيد التحضير",
    st_ready: "جاهز",
    st_sent: "تم الإرسال",
    st_canceled: "ملغي",

    // Enums
    pay_cash: "نقداً",
    pay_mobile: "دفع عبر الهاتف (بانكيلي أو غيره)",
    pay_card: "بطاقة مصرفية",
    full_collect: "استلام من المتجر",
    full_delivery: "توصيل",

    // Stats Cards
    totalRevenue: "إجمالي الإيرادات",
    totalOrders: "إجمالي الطلبات",
    monthlyRevenue: "إيرادات الشهر",
    monthlyOrders: "طلبات الشهر",
    sinceStart: "منذ البداية",
    currentMonth: "الشهر الحالي",

    // Action Cards
    manageOrders: "إدارة الطلبات",
    quickAction: "إجراء سريع",
    addEditCatalog: "إضافة / تعديل",
    catalog: "الكتالوج",
    proTip: "نصيحة احترافية",
    tipText: "أضف 8 منتجات جذابة على الأقل لزيادة مبيعاتك بنسبة 20%.",

    // Lists
    latestOrders: "أحدث الطلبات",
    realTime: "الوقت الفعلي",
    noOrders: "لا توجد طلبات حديثة.",
    client: "العميل",
    topSales: "الأكثر مبيعاً",
    byVolume: "حسب الكمية",
    noSalesData: "لا توجد بيانات مبيعات.",

    // Charts
    orderVolume: "حجم الطلبات",
    sales: "المبيعات",
    revenue: "الأرباح",

    // --- Products & Inventory ---
    inventory: "مخزوني",
    add_product: "إضافة منتج جديد",
    product_name: "اسم المنتج",
    price_mru: "السعر (أوقية)",
    stock: "المخزون",
    category: "الفئة",
    new_category: "➕ فئة جديدة",
    image_product: "صورة المنتج",
    select_image: "اختر صورة",
    save: "حفظ",
    search_product: "البحث عن منتج...",
    display_count: "عرض {count} منتجات",
    out_of_stock: "نفذ",
    edit: "تعديل",
    rupture: "نفاد",
    restock: "إمداد",
    delete_confirm: "حذف هذا المنتج؟",
    edit_product: "تعديل المنتج",
    cancel: "إلغاء",
    save_changes: "حفظ التغييرات",

    // --- Subscription ---
    my_subscription: "اشتراكي",
    paid_months: "الأشهر المدفوعة",
    year: "السنة",
    send_proof: "إرسال إثبات الدفع",
    month_concerned: "الشهر المعني",
    select_month: "اختر شهراً...",
    screenshot_receipt: "لقطة شاشة (الإيصال)",
    confirm_payment: "تأكيد الدفع",
    processing: "جاري المعالجة...",
    annual_history: "السجل السنوي",
    not_settled: "غير مدفوع",
    view_receipt: "عرض الإيصال",
    delete_proof_confirm: "حذف إثبات الدفع هذا؟",
    months_list: ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"],

    // --- Market Info ---
    public_info: "المعلومات العامة",
    client_contact: "اتصال العملاء (الهاتف)",
    phone_placeholder: "مثال: 36 12 34 56",
    opening_hours_title: "ساعات العمل (أسبوع نمطي)",
    opens_at: "يفتح عند",
    closes_at: "يغلق عند",
    closed_all_day: "مغلق طوال اليوم",
    tip_closed: "نصيحة: ضع علامة في المربع الموجود على يسار اليوم لتمييزه كـ \"مغلق\".",
    payment_methods_accepted: "وسائل الدفع المقبولة",
    payment_label_placeholder: "الاسم (مثال: بانكيلي)",
    payment_value_placeholder: "الرقم / الرمز",
    add_payment_method: "إضافة وسيلة دفع",
    update_success: "✅ تم تحديث المعلومات بنجاح!",
    saving: "جاري الحفظ...",
    save_mods: "حفظ التغييرات",
    days_list: [
      { key: "monday", label: "الاثنين" },
      { key: "tuesday", label: "الثلاثاء" },
      { key: "wednesday", label: "الأربعاء" },
      { key: "thursday", label: "الخميس" },
      { key: "friday", label: "الجمعة" },
      { key: "saturday", label: "السبت" },
      { key: "sunday", label: "الأحد" },
    ],

    // --- Settings (New) ---
    security: "الأمان",
    change_password_desc: "تغيير كلمة المرور الخاصة بك",
    current_password: "كلمة المرور الحالية",
    new_password: "كلمة المرور الجديدة",
    confirm_new_password: "تأكيد كلمة المرور",
    update_btn: "تحديث",
    pwd_changed: "تم تغيير كلمة المرور",
    error_required: "جميع الحقول مطلوبة",
    error_short: "كلمة المرور قصيرة جداً (6 أحرف على الأقل)",
    error_mismatch: "كلمات المرور غير متطابقة",
    error_server: "خطأ في الخادم",
    language_choice: "لغة الواجهة"
  }
};
